import type { Lead } from "./types";

/** One cell: quoted when it contains a comma, quote, or newline. */
export function csvCell(value: string | null | undefined): string {
  const text = value ?? "";
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function leadsToCsv(
  leads: Lead[],
  resolve: { agentName: (id?: string | null) => string; campaignName: (id: string) => string; overdueReasons: (id: string) => string[] },
): string {
  const header = ["Name", "Phone", "Email", "Company", "Campaign", "Status", "Assigned", "Overdue", "Created", "Contact ID", "Notes", "Custom fields"];
  const lines = [header.map(csvCell).join(",")];
  for (const lead of leads) {
    const overdue = resolve.overdueReasons(lead.id);
    lines.push([
      lead.name || "",
      lead.phone || "",
      lead.email || "",
      lead.company || "",
      resolve.campaignName(lead.campaignId),
      lead.status || (lead.fresh ? "Fresh lead" : "Contacted"),
      resolve.agentName(lead.assignedAgentId),
      overdue.join(" | "),
      lead.createdAt ? new Date(lead.createdAt).toLocaleString() : "",
      lead.contactId || lead.id,
      (lead.notes || "").replace(/\r?\n/g, " "),
      JSON.stringify(lead.values || {}),
    ].map(csvCell).join(","));
  }
  return lines.join("\r\n");
}

/** Trigger a download of the given rows — exactly what's on screen. */
export function downloadLeadsCsv(leads: Lead[], resolve: { agentName: (id?: string | null) => string; campaignName: (id: string) => string; overdueReasons: (id: string) => string[] }, scope: string): void {
  const stamp = new Date().toISOString().slice(0, 16).replace(/[-:T]/g, "");
  const blob = new Blob([linesWithBom(leadsToCsv(leads, resolve))], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${scope}-export-${stamp}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

// Excel misreads UTF-8 without a BOM (phone "+" prefixes and Hindi names
// garble) — the BOM is deliberate, not decorative.
function linesWithBom(csv: string): string {
  return String.fromCharCode(0xFEFF) + csv;
}
